import { render, staticRenderFns } from "./handleAdmin.vue?vue&type=template&id=6396af9b"
import script from "./handleAdmin.vue?vue&type=script&lang=js"
export * from "./handleAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports